// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3703":"4d014e37","4593":"f77bf5a7","7276":"362ed98e","7583":"13e63f8f","9972":"76a28885"}[chunkId] + ".chunk.css";
};